import React from "react";

const Unauthorized = () => {
    return <h1>Access Denied - You don’t have permission to view this page</h1>;
};

export default Unauthorized;
